import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Mission() {
  return <section id="mission" className="py-24 bg-pac-sand relative overflow-hidden" data-id="element-127">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-pac-gold/10 blur-3xl" data-id="element-128"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-130">
          <div className="inline-flex items-center justify-center p-3 bg-pac-navy text-pac-gold rounded-full mb-6 shadow-lg" data-id="element-131">
            <ShieldCheck className="h-8 w-8" data-id="element-132" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-8" data-id="element-133">
            Our Mission
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-slate-100 relative" data-id="element-134">
            {/* Quote marks decoration */}
            <span className="absolute top-4 left-6 text-6xl text-slate-200 font-serif leading-none" data-id="element-135">
              "
            </span>

            <p className="text-xl md:text-2xl text-slate-700 leading-relaxed font-medium relative z-10" data-id="element-136">
              We are a group of Leaders in the West Valley of Maricopa County in
              Arizona. We are passionate about{' '}
              <strong className="text-pac-navy" data-id="element-137">Local control</strong> in our
              cities, <strong className="text-pac-navy" data-id="element-138">zoning laws</strong>,
              and creating a{' '}
              <strong className="text-pac-navy" data-id="element-139">high quality of life</strong>{' '}
              for our residents that we serve.
            </p>

            <div className="mt-8 pt-8 border-t border-slate-100" data-id="element-140">
              <p className="text-lg text-pac-red font-bold uppercase tracking-wider" data-id="element-141">
                Get involved! Contribute to our organization and create a
                positive change in our communities.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}